function Help() {
  return (
    <div className="content-page">
      <h1>Help</h1>
      <p className="subtitle" style={{paddingBottom: '20px'}}>Everything you need to know about using Doccy.</p>

      <div className="help-card">
        <h3>How do I add a passport?</h3>
        <p>
          Tap the + button on the vault screen, then choose "Add Passport".
          You can type the details manually or tap "Scan Passport" to use your
          camera — point it at the passport's data page and Doccy will read the
          MRZ automatically.
        </p>
      </div>

      <div className="help-card">
        <h3>How do I link a visa to a passport?</h3>
        <p>
          Open a passport, scroll to the bottom, and tap "Add Visa". The visa
          will be linked to that passport. When the passport expires, Doccy
          warns you that linked visas become invalid too.
        </p>
      </div>

      <div className="help-card">
        <h3>Is my data safe?</h3>
        <p>
          Yes. All data is encrypted with AES-256-GCM before it's written to
          storage. Your encryption key is stored in the iOS Keychain, protected
          by the Secure Enclave. We have no servers and no access to your data.
        </p>
      </div>

      <div className="help-card">
        <h3>How does iCloud sync work?</h3>
        <p>
          When enabled (Pro feature), your data is encrypted on your device
          before being uploaded to your personal iCloud account via CloudKit.
          iCloud only stores encrypted blobs — neither Apple nor anyone else
          can read them. Your encryption key syncs separately via iCloud Keychain
          (end-to-end encrypted by Apple).
        </p>
      </div>

      <div className="help-card">
        <h3>How do reminders work?</h3>
        <p>
          Reminders are a Pro feature. When enabled, Doccy schedules local
          notifications at your chosen intervals (90, 60, 30, 14, 7, or 1 day
          before expiry). If a passport is expiring, Doccy also warns you about
          all linked visas and travel authorisations.
        </p>
      </div>

      <div className="help-card">
        <h3>What happens if I cancel Pro?</h3>
        <p>
          All your documents remain accessible — you can view, edit, and delete
          everything. You just can't add new documents beyond the free tier limit
          (1 passport + 2 linked docs, 2 standalone docs), and reminders and
          iCloud sync stop working.
        </p>
      </div>

      <div className="help-card">
        <h3>How do I restore my purchase?</h3>
        <p>
          Go to Settings in the app and tap "Restore Purchases". This syncs your
          purchase status with the App Store. Purchases are tied to your Apple ID,
          so they work across all your devices.
        </p>
      </div>
    </div>
  );
}

export default Help;
